import { PdFormContainer } from "./pd-form-container/PdFormContainer.js";
//#region src/pd-form-container/pd-form-container.ts
var tag = "pd-form-container";
if (!customElements.get(tag)) customElements.define(tag, PdFormContainer);
//#endregion
export { PdFormContainer };
